module.exports = __webpack_public_path__ + "static/quotemark-wht-f3bff3f2a10ba6fbdceeca27c1f710c6.gif";